const thousandSeparator = num =>
  (num + '').replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')

const declOfNum = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2]
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ]
}

const isEmptyObject = obj => {
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      return false
    }
  }
  return true
}

export { thousandSeparator, declOfNum, isEmptyObject }
